<div class="video-container">
  <div [id]="playerId" [ngStyle]="style"></div>
</div>
